import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Airports() {
  return (
    <ImageCollectionPage 
      title="Airports" 
      path="/airports" 
      collection="airports" 
    />
  );
}
